import { render, staticRenderFns } from "./ListExtrato.vue?vue&type=template&id=7b52b570"
import script from "./ListExtrato.vue?vue&type=script&lang=js"
export * from "./ListExtrato.vue?vue&type=script&lang=js"
import style0 from "./ListExtrato.vue?vue&type=style&index=0&id=7b52b570&prod&lang=scss"
import style1 from "./ListExtrato.vue?vue&type=style&index=1&id=7b52b570&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports